import { openDocumentSettingsScreen } from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Signals/documentSettingsScreenSignal';
import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import { css } from '@emotion/react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const actionsStyle = css`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

type Props = {
	readonly stageIndex: number;
	readonly stepIndex: number;
};

/** Leaf actions of a document row: open its settings through the signal, or remove it from the stage. */
const DocumentRowActions: React.FC<Props> = ({ stageIndex, stepIndex }) => {
	const { setDraft } = useWorkflowDraft();

	const handleSettingsClick = React.useCallback(() => {
		openDocumentSettingsScreen(stageIndex, stepIndex);
	}, [stageIndex, stepIndex]);

	const handleRemoveClick = React.useCallback(() => {
		setDraft((current) => current.removeDocument(stageIndex, stepIndex));
	}, [setDraft, stageIndex, stepIndex]);

	return (
		<div css={actionsStyle}>
			<Button type="button" size="sm" label="Régler" onClick={handleSettingsClick} />
			<Button
				type="button"
				size="sm"
				severity="secondary"
				label="Retirer"
				onClick={handleRemoveClick}
			/>
		</div>
	);
};

export default DocumentRowActions;
